import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { toast } from "sonner";
import { ThumbsUp, ThumbsDown } from "lucide-react";

export default function ReactionBar({ targetType, targetId, likes = 0, dislikes = 0, mine = 0, testidPrefix = "reaction" }) {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [state, setState] = useState({ likes, dislikes, my: mine });
  const [busy, setBusy] = useState(false);

  useEffect(() => { setState({ likes, dislikes, my: mine }); }, [likes, dislikes, mine, targetId]);

  const react = async (value) => {
    if (!user || user === false) {
      toast.error(t("reactions.loginRequired"));
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/reactions", { target_type: targetType, target_id: targetId, value });
      setState({ likes: data.likes, dislikes: data.dislikes, my: data.my_reaction });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => react(1)}
        disabled={busy}
        data-testid={`${testidPrefix}-like`}
        className={`flex items-center gap-1.5 border px-3 py-1.5 text-sm font-semibold transition-colors ${
          state.my === 1 ? "border-truth bg-truth/15 text-truth" : "border-white/15 text-muted-foreground hover:border-truth/50 hover:text-truth"
        }`}
      >
        <ThumbsUp className="h-4 w-4" /> {state.likes}
      </button>
      <button
        onClick={() => react(-1)}
        disabled={busy}
        data-testid={`${testidPrefix}-dislike`}
        className={`flex items-center gap-1.5 border px-3 py-1.5 text-sm font-semibold transition-colors ${
          state.my === -1 ? "border-lie bg-lie/15 text-lie" : "border-white/15 text-muted-foreground hover:border-lie/50 hover:text-lie"
        }`}
      >
        <ThumbsDown className="h-4 w-4" /> {state.dislikes}
      </button>
    </div>
  );
}
